import template     from 'designer/mobile-thumb-page-behaviors-only.ejs';
import constants from 'Constants';
import thumbPageListUtil from 'util/ThumbPageListUtil.js';
import MobileThumbPageItemView from './MobileThumbPageItemView';

const SILENT = constants.MODEL_SILENT;

//=========================================================
// This is a view on a single thumbnail page item
//=========================================================
class MobileThumbPageBehaviorsOnlyView extends MobileThumbPageItemView {
    
    initialize( opts ) {
        this.options = opts || {};

        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;

        this.model.set("hasActiveBehaviors", false, {SILENT});
        this.model.set("behaviorsOnly", opts.behaviorsOnly, {silent:true});

        return this;
    }

}

export default MobileThumbPageBehaviorsOnlyView;
